import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentEditFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 8a1 1 0 0 1-1 1H3l-2 2V2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6ZM8.5 3.5l-.607.607-1-1L7.5 2.5l1 1Zm-1.893-.107 1 1L4.5 7.5h-1v-1l3.107-3.107Z"
    />
  </svg>
);
export default IconCommentEditFilledSizeXs;
